/**
 * Download a blob to file
 * @param blob the blob to download
 * @param filename the name of the file
 */
export const DownloadBlobAsFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.click();
  link.remove();
  return;
};
